import { useContext } from 'react'
import { Row, Col } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { PlayerContext } from '../../pages/Home'
import { getAlbumUrl } from '../../api/api.cdlbt.co'

const RecordingInfo = () => {
  const { nowPlaying } = useContext(PlayerContext)
  if (!nowPlaying) return ''

  const recordingLink = `/recording/${nowPlaying.name}`
  const makeLink = `/chassis/${nowPlaying.vehicle.chassis.partMake.makeId}`
  const chassisLink = `${makeLink}/${nowPlaying.vehicle.chassis.partId}`
  const operatorLink = `/operator/${nowPlaying.name}`
  return (
    <Row className='d-inline-flex'>
      <Col>
        <img
          className={`rounded player-album ${
            nowPlaying.vehicle.chassis.partMake.makeId
          } ${nowPlaying.hd ? 'recording-card-img-hd' : ''}`}
          src={getAlbumUrl(
            nowPlaying.vehicle.body.partMake.makeId,
            nowPlaying.vehicle.body.partId
          )}
          alt={nowPlaying.name}
        />
      </Col>
      <Col className='d-flex flex-column justify-content-center flex-grow-1'>
        <h6 className='mb-1 fw-semibold text-truncate'>
          <Link
            to={makeLink}
            className='text-body link-underline link-underline-opacity-0 link-underline-opacity-75-hover'
          >
            {nowPlaying.vehicle.chassis.partMake?.makeName}
          </Link>{' '}
          <Link
            to={chassisLink}
            className='text-body link-underline link-underline-opacity-0 link-underline-opacity-75-hover'
          >
            {nowPlaying.vehicle.chassis.partName}
          </Link>
        </h6>
        <h5 className='mb-0 fw-bold'>
          <Link to={recordingLink} className='reg'>
            {nowPlaying.vehicle.regName}
          </Link>
        </h5>
        <small className='d-block text-truncate'>
          <Link
            to={operatorLink}
            className='text-body link-underline link-underline-opacity-0 link-underline-opacity-75-hover'
          >
            {nowPlaying.vehicle.op?.opName}
          </Link>
          {nowPlaying.vehicle.fleetNo ? ` - ${nowPlaying.vehicle.fleetNo}` : ''}
        </small>
      </Col>
    </Row>
  )
}
export default RecordingInfo
